import { StyledElement, defineElement } from '@webtides/element-js';
import style from './tab-link.css';
import { TabSelectEvent } from '../../events/tab-select-event.js';

/**
 * @property {string} for
 * @property {boolean} selected
 * @property {string} variant
 * @property {TabRegisterStore} tabRegisterStore
 */
export default class TabLink extends StyledElement {
    constructor() {
        super({ styles: [style], propertyOptions: { variant: { reflect: true } } });
    }

    properties() {
        return {
            for: undefined,
            selected: false,
            variant: 'default', // 'default' || 'defaultBottom' || 'button'
        };
    }

    injectProperties() {
        return {
            /** @type {TabRegisterStore} */
            tabRegisterStore: (tabRegisterStore) => {
                tabRegisterStore.register('link', this);
            },
        };
    }

    connected() {
        // Accessibility
        this.setAttribute('role', 'tab');
        this.setAttribute('id', `tab-link-${this.for}`);
        this.setAttribute('aria-controls', `tab-panel-${this.for}`);
        this.setAttribute('aria-selected', `${this.selected}`);
        this.setAttribute('tabindex', this.selected ? '0' : '-1');
    }

    afterUpdate() {
        // Accessibility
        this.setAttribute('aria-selected', `${this.selected}`);
        this.setAttribute('tabindex', this.selected ? '0' : '-1');
    }

    watch() {
        return {
            selected: (selected) => {
                this.toggleAttribute('active', selected);
            },
        };
    }

    events() {
        return {
            this: {
                click: (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    if (this.hasAttribute('disabled')) return;
                    this.dispatchEvent(new TabSelectEvent(this.for, this.textContent));
                },
                focus: (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    if (this.hasAttribute('disabled')) return;
                    this.dispatchEvent(new TabSelectEvent(this.for, this.textContent));
                },
            },
        };
    }
}

defineElement('mb-tab-link', TabLink);
